// Full menu data extracted from Hayalan Coffee menu photos
// Prices in thousands of Rupiah (e.g., 18 = Rp 18.000)

// Image map for menu items that have real photos. Items not listed
// fall back to a category-based illustration in the card UI.
export const menuImages = {
  "Matcha Hayalan":
    "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/0p740799_WhatsApp%20Image%202026-05-18%20at%2017.53.53%20%281%29.jpeg",
  "Matcha Latte":
    "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/0p740799_WhatsApp%20Image%202026-05-18%20at%2017.53.53%20%281%29.jpeg",
  "Matcha Macchiato":
    "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/0p740799_WhatsApp%20Image%202026-05-18%20at%2017.53.53%20%281%29.jpeg",
  "Matcha Coconut":
    "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/0p740799_WhatsApp%20Image%202026-05-18%20at%2017.53.53%20%281%29.jpeg",
  // Unsplash fallbacks for popular items
  "Latte Hayalan":
    "https://images.unsplash.com/photo-1561882468-9110e03e0f78?w=600&q=85&auto=format&fit=crop",
  "Caramel Macchiato Hayalan":
    "https://images.unsplash.com/photo-1534349842105-3ca31a513556?w=600&q=85&auto=format&fit=crop",
  "Butterscotch Macchiato Hayalan":
    "https://images.unsplash.com/photo-1534349842105-3ca31a513556?w=600&q=85&auto=format&fit=crop",
  "Latte": "https://images.unsplash.com/photo-1561882468-9110e03e0f78?w=600&q=85&auto=format&fit=crop",
  Cappuccino:
    "https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=600&q=85&auto=format&fit=crop",
  Americano:
    "https://images.unsplash.com/photo-1542990253-a781e04c0082?w=600&q=85&auto=format&fit=crop",
  "Long Black":
    "https://images.unsplash.com/photo-1542990253-a781e04c0082?w=600&q=85&auto=format&fit=crop",
  "Flat White":
    "https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=600&q=85&auto=format&fit=crop",
  "Redvelvet Latte":
    "https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=600&q=85&auto=format&fit=crop",
  "Dark Chocolate":
    "https://images.unsplash.com/photo-1542990253-a781e04c0082?w=600&q=85&auto=format&fit=crop",
  "Dark Chocolate Macchiato":
    "https://images.unsplash.com/photo-1542990253-a781e04c0082?w=600&q=85&auto=format&fit=crop",
  "Cookies & Cream":
    "https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=600&q=85&auto=format&fit=crop",
  "Strawberry Yakult":
    "https://images.unsplash.com/photo-1546171753-97d7676e4602?w=600&q=85&auto=format&fit=crop",
  "Virgin Mojito":
    "https://images.unsplash.com/photo-1546171753-97d7676e4602?w=600&q=85&auto=format&fit=crop",
  "Virgin Lychee Mojito":
    "https://images.unsplash.com/photo-1604321115296-f4b73745c7d9?w=600&q=85&auto=format&fit=crop",
  "Strawberry Mocktail":
    "https://images.unsplash.com/photo-1546171753-97d7676e4602?w=600&q=85&auto=format&fit=crop",
  "Magic Hayalan":
    "https://images.unsplash.com/photo-1604321115296-f4b73745c7d9?w=600&q=85&auto=format&fit=crop",
  "Blue Sky":
    "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=600&q=85&auto=format&fit=crop",
  "Thai Tea":
    "https://images.unsplash.com/photo-1597318181409-cf64d0b5d8a2?w=600&q=85&auto=format&fit=crop",
  "Blackcurrant Tea":
    "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=600&q=85&auto=format&fit=crop",
  "Strawberry Tea":
    "https://images.unsplash.com/photo-1546171753-97d7676e4602?w=600&q=85&auto=format&fit=crop",
  "Pandan Tea":
    "https://images.unsplash.com/photo-1597318181409-cf64d0b5d8a2?w=600&q=85&auto=format&fit=crop",
  "Avocado Hayalan":
    "https://images.unsplash.com/photo-1515823064-d6e0c04616a7?w=600&q=85&auto=format&fit=crop",
  "Regal Biscoffee Hayalan":
    "https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=600&q=85&auto=format&fit=crop",
  "Butterscotch Sea Salt Caramel":
    "https://images.unsplash.com/photo-1534349842105-3ca31a513556?w=600&q=85&auto=format&fit=crop",
};

export const menuData = {
  hayalan: [
    { name: "Latte Hayalan", price: 18, signature: true },
    { name: "Palm Sugar Hayalan", price: 22 },
    { name: "Pandan Hayalan", price: 25 },
    { name: "Caramel Hayalan", price: 25 },
    { name: "Mocca Hayalan", price: 28, signature: true },
    { name: "Butterscotch Hayalan", price: 25, signature: true },
    { name: "Hazelnut Hayalan", price: 25 },
    { name: "Vanilla Hayalan", price: 28 },
    { name: "Nutella Hayalan", price: 28, signature: true },
    { name: "Latte Macchiato Hayalan", price: 28 },
    { name: "Caramel Macchiato Hayalan", price: 30 },
    { name: "Butterscotch Macchiato Hayalan", price: 30, signature: true },
    { name: "Oatmilk Latte", price: 25 },
    { name: "Coconut Latte", price: 23 },
  ],
  arabica: [
    { name: "Latte", hot: 21, ice: 23, signature: true },
    { name: "Cappuccino", hot: 21, ice: 23 },
    { name: "Americano", hot: 15, ice: 18 },
    { name: "Coconut Americano", ice: 22, signature: true },
    { name: "Long Black", hot: 15, ice: 18 },
    { name: "Flat White", hot: 23 },
  ],
  noncoffee: [
    { name: "Redvelvet Latte", hot: 18, ice: 20 },
    { name: "Royal Choco", ice: 18 },
    { name: "Matcha Latte", hot: 24, ice: 26 },
    { name: "Matcha Hayalan", ice: 28, signature: true },
    { name: "Matcha Macchiato", ice: 28 },
    { name: "Redvelvet Macchiato", ice: 22 },
    { name: "Dark Chocolate Macchiato", ice: 30, signature: true },
    { name: "Dark Chocolate", hot: 26 },
    { name: "Cookies & Cream", ice: 23 },
    { name: "Susu Pandan", ice: 23, signature: true },
    { name: "Strawberry Yakult", ice: 23, signature: true },
    { name: "Calamansi Orange", ice: 20, signature: true },
    { name: "Coconut Pandan", ice: 18 },
    { name: "Apple Milky Sour", ice: 25 },
  ],
  mocktail: [
    { name: "Virgin Mojito", price: 18, signature: true },
    { name: "Virgin Lychee Mojito", price: 25, signature: true },
    { name: "Blue Sky", price: 20 },
    { name: "Strawberry Mocktail", price: 25, signature: true },
    { name: "Magic Hayalan", price: 23, signature: true },
  ],
  tea: [
    { name: "Apple Tea", price: 18 },
    { name: "Blackcurrant Tea", price: 15, signature: true },
    { name: "Blackcurrant Tea Yakult", price: 18 },
    { name: "Lemon Tea", price: 18 },
    { name: "Lychee Tea", price: 20 },
    { name: "Longan Tea", price: 20 },
    { name: "Strawberry Tea", price: 15, signature: true },
    { name: "Pandan Tea", price: 15, signature: true },
    { name: "Thai Tea", price: 18, signature: true },
  ],
  signature: [
    { name: "Avocado Hayalan", price: 30 },
    { name: "Butterscotch Sea Salt Caramel", price: 28 },
    { name: "Matcha Coconut", price: 32 },
    { name: "Regal Biscoffee Hayalan", price: 28 },
  ],
};

// Featured items shown on landing page (homepage)
export const featuredItems = [
  {
    name: "Butterscotch Macchiato Hayalan",
    desc_id:
      "Macchiato Hayalan dengan butterscotch creamy yang viral di kalangan pelanggan.",
    desc_en:
      "Hayalan macchiato with creamy butterscotch — a customer-viral signature.",
    price: 30,
    category: "Hayalan Series",
    image:
      "https://images.unsplash.com/photo-1534349842105-3ca31a513556?w=900&q=85&auto=format&fit=crop",
  },
  {
    name: "Matcha Hayalan",
    desc_id:
      "Matcha grade premium dipadu signature Hayalan — segar, halus, dan creamy.",
    desc_en:
      "Premium-grade matcha meets the Hayalan signature — fresh, smooth, and creamy.",
    price: 28,
    category: "Non-Coffee",
    image:
      "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/0p740799_WhatsApp%20Image%202026-05-18%20at%2017.53.53%20%281%29.jpeg",
  },
  {
    name: "Virgin Lychee Mojito",
    desc_id:
      "Mojito non-alkohol dengan kelopak lychee dan mint segar yang menyegarkan.",
    desc_en:
      "A non-alcoholic mojito with lychee petals and fresh mint — utterly refreshing.",
    price: 25,
    category: "Mocktail",
    image:
      "https://images.unsplash.com/photo-1604321115296-f4b73745c7d9?w=900&q=85&auto=format&fit=crop",
  },
  {
    name: "Matcha Coconut",
    desc_id:
      "Signature menu — matcha bertemu santan, manis lembut khas pulau.",
    desc_en:
      "A signature menu — matcha meets coconut for a softly sweet island sip.",
    price: 32,
    category: "Signature",
    image:
      "https://images.unsplash.com/photo-1515823064-d6e0c04616a7?w=900&q=85&auto=format&fit=crop",
  },
  {
    name: "Regal Biscoffee Hayalan",
    desc_id:
      "Espresso Hayalan dengan crumble biscoff — manis caramel yang memorable.",
    desc_en:
      "Hayalan espresso with Biscoff crumble — a memorable caramel sweetness.",
    price: 28,
    category: "Signature",
    image:
      "https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=900&q=85&auto=format&fit=crop",
  },
  {
    name: "Latte Hayalan",
    desc_id:
      "Latte signature yang jadi favorit pelanggan — creamy, balance, ramah harga.",
    desc_en:
      "The signature latte favorite — creamy, balanced, and friendly on the wallet.",
    price: 18,
    category: "Hayalan Series",
    image:
      "https://images.unsplash.com/photo-1561882468-9110e03e0f78?w=900&q=85&auto=format&fit=crop",
  },
];

// Gallery images (mix of cafe interior, coffee, food, vibe) — real Hayalan photos prioritized
export const galleryImages = [
  {
    src: "https://customer-assets.emergentagent.com/job_6cdd41fe-c52f-4497-b3aa-231d2a7762b9/artifacts/r5qrktqg_WhatsApp%20Image%202026-05-18%20at%2017.53.53.jpeg",
    alt: "Hayalan Coffee storefront at night",
    span: "tall",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/0p740799_WhatsApp%20Image%202026-05-18%20at%2017.53.53%20%281%29.jpeg",
    alt: "Matcha Hayalan signature drinks",
    span: "normal",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/r65adk60_WhatsApp%20Image%202026-05-18%20at%2017.53.54.jpeg",
    alt: "Hayalan dessert display — cakes & sweets",
    span: "wide",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/kngkc509_WhatsApp%20Image%202026-05-18%20at%2017.53.54%20%281%29.jpeg",
    alt: "Hayalan Coffee street signage at night",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1521017432531-fbd92d768814?w=900&q=85",
    alt: "Iced coffee close up",
    span: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=900&q=85",
    alt: "Cafe interior wooden tones",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1453614512568-c4024d13c247?w=900&q=85",
    alt: "Pour over coffee setup",
    span: "wide",
  },
  {
    src: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=900&q=85",
    alt: "Hot latte and biscuits",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1518057111178-44a106bad636?w=900&q=85",
    alt: "Aesthetic table flatlay",
    span: "tall",
  },
];

export const BRAND = {
  name: "Hayalan Coffee",
  tagline_id: "Make Your Dreams Happen",
  tagline_en: "Make Your Dreams Happen",
  phone: "+6285191500909",
  phoneDisplay: "0851-9150-0909",
  address:
    "Jl. Kapten Sulaiman Arief No.170, Pangkalpinang, Bangka Belitung",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Hayalan+Coffee+Jl.+Kapten+Sulaiman+Arief+No.170+Pangkalpinang",
  mapsEmbed:
    "https://www.google.com/maps?q=Jl.+Kapten+Sulaiman+Arief+No.170+Pangkalpinang&output=embed",
  ig: "https://instagram.com/hayalan.coffee",
  tiktok: "https://tiktok.com/@hayalan.coffee",
  logo: "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/wu49gajb_WhatsApp%20Image%202026-05-18%20at%2016.22.00%20%282%29.jpeg",
  storefront:
    "https://customer-assets.emergentagent.com/job_6cdd41fe-c52f-4497-b3aa-231d2a7762b9/artifacts/r5qrktqg_WhatsApp%20Image%202026-05-18%20at%2017.53.53.jpeg",
  // Real Hayalan Coffee photos provided by owner
  realMatcha:
    "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/0p740799_WhatsApp%20Image%202026-05-18%20at%2017.53.53%20%281%29.jpeg",
  realSignage:
    "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/kngkc509_WhatsApp%20Image%202026-05-18%20at%2017.53.54%20%281%29.jpeg",
  realDessert:
    "https://customer-assets.emergentagent.com/job_premium-brew-73/artifacts/r65adk60_WhatsApp%20Image%202026-05-18%20at%2017.53.54.jpeg",
  hero:
    "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1800&q=85&auto=format&fit=crop",
};
